import { RoleEnum } from "../../types/RoleEnum";
import { Kult0501ReportForm } from "./Kult0501ReportForm";
import { Kult1501ReportForm } from "./Kult1501ReportForm";
export var OUTPUT_REPORTS = [
    {
        key: "kult-15-01",
        labelId: "ui-br-legaldeposits.outputs.report.kult-15-01",
        allowedRoles: [
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
        ],
        Component: Kult1501ReportForm,
    },
    {
        key: "kult-05-01",
        labelId: "ui-br-legaldeposits.outputs.report.kult-05-01",
        allowedRoles: [
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
        ],
        Component: Kult0501ReportForm,
    },
];
